export default __webpack_public_path__ + "static/media/hooked.6e466764.png";